import { render, staticRenderFns } from "./swyxzmInfo.vue?vue&type=template&id=49d2d040&scoped=true&"
import script from "./swyxzmInfo.vue?vue&type=script&lang=js&"
export * from "./swyxzmInfo.vue?vue&type=script&lang=js&"
import style0 from "./swyxzmInfo.vue?vue&type=style&index=0&id=49d2d040&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d2d040",
  null
  
)

export default component.exports